import classes from "./about.module.css";

const timeline = [
  {
    type: "education",
    title: "Bachelor of Robotics And Automation",
    institution: "Medi-Caps University",
    start: "Aug 2022",
    end: "Jun 2026",
    description: [
      "Pursuing an interdisciplinary program combining mechanical engineering, electronics, and computer science. Focused on automation systems, robotics design, and intelligent control through practical labs and real-world projects.",
    ],
  },
  {
    type: "experience",
    title: "Software Developer - Internship",
    company: "Mento.in",
    start: "Jan 2025",
    end: "Jan 2026",
    description: [
      "I drive front-end development using React.js and AWS to create scalable systems.",
      "My responsibilities include designing key features, working with cross-functional teams, and enhancing to boost platform performance, scalability, and overall user experience.",
    ],
  },
  {
    type: "experience",
    title: "Business Development Executive",
    company: "Barna International General Trading LLC - Dubai, UAE",
    start: "Jun 2024",
    end: "Aug 2024",
    description: [
      "Designed websites using WordPress, with experience in theme customization, plugin integration, and domain management.",
      "Implemented marketing strategies including SEO and branding to enhance the company's digital presence.",
    ],
    link:"https://drive.google.com/file/d/1WHUQmEf9MjX8sgMdyRP2IAnCKOJvZvFx/view?usp=sharing"
  },
  {
    type: "experience",
    title: "Research Intern - FTIR Gas Detection ",
    company: "IIT Guwahati - Guwahati, Assam, India",
    start: "Jun 2025",
    end: "Aug 2025",
    description: [
      "Developed functional prototype using IR sensors and FTIR techniques for gas detection and analysis",
      "Integrated real-time sensor data into intelligent detection framework, improving monitoring precision"
    ],
    link: "https://drive.google.com/file/d/17FuuAZGvKpRSM154Rzdijv4tx9JZEznC/view?usp=sharing"
  },
];

const CardInfo = () => {
  return (
    <>
      {timeline.map((item, index) => (
        <div key={index} className={classes.cardAbout}>
          <div className={classes.cardAboutContainer}>
            <div className={classes.cardAboutTitle}>{item.title}</div>
            
            <p className={classes.AboutTitle}>
              @ {item.institution || item.company}
              <p></p>
              {item.location && `, ${item.location}`}
            </p>
            <p className={classes.aboutTime}>
              <span>
                {item.start} - {item.end}
              </span>
            </p>
            
            {item.description && (
              <div className={classes.aboutDescription}>
                {item.description.map((desc, descIndex) => (
                  <p key={descIndex}>{desc}</p>
                ))}
              </div>
            )}
            
            {item.link && (
              <a 
                href={item.link} 
                target="_blank" 
                rel="noopener noreferrer"
                className={classes.viewButton}
              >
                View
              </a>
            )}
          </div>
        </div>
      ))}
    </>
  );
};

export default CardInfo;